// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { TypographyPresentationProps } from "@insite/mobius/Typography";
import { cartActionsStyles } from "@steiner/Overrides/Widgets/Cart/CartActions";
import SaveCart from "@steiner/XDL/Icons/SaveCart";
import { addToCartButtonStyles } from "@steiner/XDL/PreStyle/button";
import { css } from "styled-components";

const sharedLinkTextStyle: TypographyPresentationProps = {
    size: 12,
    lineHeight: "15px",
};

cartActionsStyles.container = {
    css: css`
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
        gap: 12px;
    `,
};

cartActionsStyles.leftContainer = {
    css: css`
        display: flex;
        flex: 1;
        flex-wrap: wrap;
        gap: 12px 24px;
    `,
};

cartActionsStyles.rightContainer = {
    css: css`
        display: flex;
    `,
};

cartActionsStyles.saveOrderLink = {
    typographyProps: {
        ...sharedLinkTextStyle,
    },
    icon: {
        iconProps: {
            size: 12,
            src: SaveCart,
        },
    },
};

cartActionsStyles.printLink = {
    typographyProps: {
        ...sharedLinkTextStyle,
    },
    icon: {
        iconProps: {
            size: 12,
            src: "Printer",
        },
    },
};

cartActionsStyles.addAllProductGroupLink = {
    typographyProps: {
        ...sharedLinkTextStyle,
    },
    icon: {
        iconProps: {
            size: 12,
            src: "Plus",
        },
    },
};

cartActionsStyles.removeAllLink = {
    typographyProps: {
        ...sharedLinkTextStyle,
    },
    icon: {
        iconProps: {
            size: 12,
            src: "X",
        },
    },
};

cartActionsStyles.checkoutButton = {
    ...addToCartButtonStyles,
};
